import NL_TRANSLATIONS from "./nl.json";

const TRANSLATIONS = {
  nl: NL_TRANSLATIONS,
};

export const LOCALES = ["nl"];
export const DEFAULT_LOCALE = "nl";

export default class I18n {
  constructor(locale = DEFAULT_LOCALE) {
    this.locale = locale;
  }

  t(keyOrKeys, interpolations = {}) {
    const keys = Array.isArray(keyOrKeys) ? keyOrKeys : keyOrKeys.split(".");
    let translation = keys.reduce((scope, key) => {
      if (scope) return scope[key];
    }, TRANSLATIONS[this.locale]);

    if (translation === undefined) {
      // eslint-disable-next-line no-console
      console.error(`Translation ${keys.join(".")} could not be found`);
    } else if (typeof translation === "string") {
      Object.entries(interpolations).forEach(
        ([key, value]) =>
          (translation = translation.replaceAll(`{{${key}}}`, value)),
      );
    }

    return translation;
  }
}

export function translatedPropertyFromKey(translationKey, interpolations) {
  return LOCALES.reduce((accumulator, locale) => {
    return Object.assign(accumulator, {
      [locale]: new I18n(locale).t(translationKey, interpolations),
    });
  }, {});
}
